import { ClassifiedMarkers } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { EventMapXgGradient } from './EventMapXgGradient';

export const EventMapXgLegend = () => {
  const { t } = useTranslation('visualisation');

  return (
    <>
      <EventMapXgGradient />
      <ClassifiedMarkers title={t('xgColouring.noXg')} markers={[{ label: t('xgColouring.nonShotEvent') }]} />
    </>
  );
};
